function updateFileUpload() {
  // Select all file-upload blocks on the page
  const fileUploads = document.querySelectorAll('.file-upload');
  const body = document.body;

  fileUploads.forEach((fileUpload) => {
    // Query the elements within this file-upload block
    const dropZone = fileUpload;
    const fileDefault = fileUpload.querySelector('#file-default');
    const loader = fileUpload.querySelector('#file-loading');
    const fileNameDisplay = fileUpload.querySelector('#file-name');
    const fileInput = fileUpload.querySelector('input[type="file"]');

    // Helper functions
    function isValidFileType(file) {
      const allowedAttr = fileInput.getAttribute('allowed') || '';
      const validTypes = allowedAttr.split(',').map((type) => type.trim());
      if (validTypes.includes(file.type)) return true;
      const extension = file.name.split('.').pop().toLowerCase();
      return validTypes.includes(extension);
    }

    function processFiles(files, callback) {
      setTimeout(() => {
        Array.from(files).forEach((file) => {
          console.log('File name:', file.name);
        });
        callback();
      }, 500);
    }

    function showLoader(display) {
      loader.hidden = !display;
      fileDefault.hidden = display;
      fileNameDisplay.hidden = display;
    }

    function updateFileNameDisplay(fullFileName) {
      const lastDotIndex = fullFileName.lastIndexOf('.');
      const name = fullFileName.substring(0, lastDotIndex);
      const extension = fullFileName.substring(lastDotIndex + 1);
      fileNameDisplay.innerHTML = `Uploaded File: <div><span class="filename">${name}</span>.<span class="extension">${extension}</span></div>`;
      fileNameDisplay.hidden = false;
    }

    function handleFileDrop(files) {
      const validFiles = Array.from(files).filter(isValidFileType);

      if (validFiles.length > 0) {
        fileInput.files = files;
        showLoader(true);
        processFiles(files, () => {
          showLoader(false);
          updateFileNameDisplay(files[0].name);
        });
        fileUpload.classList.remove('file-error');
        fileUpload.classList.add('file-success');
      } else {
        fileUpload.classList.remove('file-success');
        fileUpload.classList.add('file-error');
        fileNameDisplay.hidden = true;
        console.log('File type not valid.');
      }
    }

    // When the drop zone is clicked, trigger the file input
    dropZone.addEventListener('click', () => {
      fileInput.click();
      fileUpload.classList.remove('file-error', 'file-success');
    });

    // Handle drag over anywhere on body
    body.addEventListener('dragover', (event) => {
      event.stopPropagation();
      event.preventDefault();
      event.dataTransfer.dropEffect = 'grab';
      body.classList.add('is-dragging');
    });

    // Remove dragging style on drag leave
    body.addEventListener('dragleave', (event) => {
      if (event.clientX <= 0 || event.clientY <= 0 || event.clientX >= window.innerWidth || event.clientY >= window.innerHeight) {
        body.classList.remove('is-dragging');
      }
    });

    // Handle file drop anywhere on body
    body.addEventListener('drop', (event) => {
      event.preventDefault();
      event.stopPropagation();
      body.classList.remove('is-dragging');
      handleFileDrop(event.dataTransfer.files);
    });

    // Listen for file selection via the file input
    fileInput.addEventListener('change', () => {
      body.classList.remove('is-dragging');

      if (fileInput.files.length > 0) {
        handleFileDrop(fileInput.files);
      } else {
        console.log('No files selected.');
        fileUpload.classList.remove('file-error');
      }
    });
  });
}
updateFileUpload();

function updateVIN() {
  // Select all input elements with an ID starting with "vin-"
  const vinInputs = document.querySelectorAll('[id^="vin-"]');

  vinInputs.forEach(function (input) {
    // Check if there's already a message element directly after the input
    let vinMessage = input.nextElementSibling;
    if (!(vinMessage && vinMessage.id && vinMessage.id.startsWith("vin-message"))) {
      // Create a unique message element associated with this input
      vinMessage = document.createElement("p");
      vinMessage.id = "vin-message-" + input.id;
      vinMessage.classList.add('vin-message', 'label', 'mt-3');

      input.insertAdjacentElement('afterend', vinMessage);
    }

    // Handle VIN changes for this input
    input.addEventListener("input", function () {

      const vin = this.value.trim();

      // Always set a default invalid state until proven valid
      // this.setCustomValidity("VIN is invalid");

      // Check VIN length
      if (vin.length !== 17) {
        vinMessage.textContent = "VIN must be 17 characters";
        vinMessage.classList.add("vin-invalid");
        this.setCustomValidity("VIN is invalid");
        return;
      }

      // Clear previous messages and remove invalid class before API validation
      vinMessage.textContent = "";
      vinMessage.classList.remove("vin-invalid");
      this.setCustomValidity("");

      // Make API call to decode VIN with a timeout
      // fetch(`https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/${vin}?format=json`, { method: 'GET', timeout: 5000 })
      //   .then(response => response.json())
      //   .then(data => {
      //     const results = data.Results;
      //     const errorCode = results.find(item => item.Variable === "Error Code")?.Value;
      //     // If VIN is valid, clear the error so the input becomes valid.
      //     if (errorCode === "0") {
      //       vinMessage.innerHTML = `{%- render 'icons', icon: 'check', height: 14, width: 14 -%} VIN is valid`;
      //       this.setCustomValidity("");
      //     } else {
      //       vinMessage.textContent = "VIN is invalid";
      //       vinMessage.classList.add("vin-invalid");
      //       this.setCustomValidity("VIN is invalid");
      //     }
      //   })
      //   .catch(error => {
      //     console.log("Failed to fetch VIN data (timeout or error):", error);
      //     // Optionally, leave the input invalid if the API fails.
      //     vinMessage.textContent = "";
      //   });
    });
  });
};
updateVIN();

document.addEventListener('product:replaced', () => {
  updateVIN();
  updateFileUpload();
});